module.exports = __webpack_public_path__ + "media/bootstrap-icons/bag-plus-fill-9a01f99b.svg";